import React from "react";
import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const referenciasCol1 = [
  {
    nombre: "Capilla San Cayetano",
    link: "https://maps.app.goo.gl/woXPLDqG8wxyawTY9",
    direccion: "25 de Mayo 302-400.",
  },
  {
    nombre: "Capilla Virgen de la Medalla Milagrosa",
    link: "https://maps.app.goo.gl/M5ZifSnTirSwpih17",
    direccion: "Bartolomé Mitre 901-999.",
  },
  {
    nombre: "Iglesia Sagrado Corazón de Jesús",
    link: "https://maps.app.goo.gl/cNpzg1xyVpFud8339",
    direccion: "Don Bosco.",
  },
  {
    nombre: "AeroClub Oliva",
    link: "https://maps.app.goo.gl/UzK5FGxeZYqcZNRw6",
    direccion: "Ruta Nacional N°9.",
  },
  {
    nombre: "Estación Oliva FC Mitre",
    link: "https://maps.app.goo.gl/Fz76CGL4aFT2mcUbA",
    direccion: "Sin Dirección.",
  },
  {
    nombre: "Museo Nacional de Malvinas",
    link: "https://maps.app.goo.gl/TPDYkXHe9Xrmngpg7",
    direccion: "Roque Saenz Peña, Pueyrredón y.",
  },
  {
    nombre: "Biblioteca Juventud Unida",
    link: "https://maps.app.goo.gl/XMdF3ukovq8rEUV47",
    direccion: "Av. Olmos 350.",
  },
  {
    nombre: "Asociación Italiana de Socorros Mutuos “Giuseppe Mazzini”",
    link: "https://maps.app.goo.gl/9AgVJRFWou9sbS2s7",
    direccion: "Roque Sáenz Peña 76/78.",
  },
  {
    nombre: "Asociación Española de Socorros Mutuos",
    link: "https://maps.app.goo.gl/nwwCmCoNRdRZukFd7",
    direccion: "Colón 157.",
  },
];

const referenciasCol2 = [
  {
    nombre: "Paseo de la Estación",
    link: "https://maps.app.goo.gl/cTC9LQgYKJ1A3fz17",
    direccion: "Roque Sáenz Peña 301.",
  },
  {
    nombre: "Fabrica Fiori",
    link: "https://maps.app.goo.gl/rb31yoNLRexPyaQRA",
    direccion: "Ruta Provincial 10, Oliva, Córdoba",
  },
  {
    nombre: "Oficina de Turismo",
    link: "https://maps.app.goo.gl/qnMeqa6yqtqWF3Si9",
    direccion: "Roque Sáenz Peña S/N.",
  },
  {
    nombre: "Hospital Dr. Emilio Vidal Abal",
    link: "https://maps.app.goo.gl/GEaLxAKTzrh5jdSW7",
    direccion: "Ruta Nacional 9 Km. 609.",
  },
  {
    nombre: "Municipalidad de Oliva",
    link: "https://maps.app.goo.gl/zgtRYuYW8EK9EmdSA",
    direccion: "Belgrano 292.",
  },
  {
    nombre: "Centro Civico - Municipalidad De Oliva",
    link: "https://maps.app.goo.gl/Ai1kYMG6ZcMPieje8",
    direccion: "Pueyrredón 201.",
  },
  {
    nombre: "Auditorium Municipal",
    link: "https://maps.app.goo.gl/3oGZqcg7mt29D9r38",
    direccion: "Colón 157.",
  },
  {
    nombre: "Sociedad Rural de Oliva",
    link: "https://maps.app.goo.gl/dSPuBveZ2VSsjd8M7",
    direccion: "La Rioja 701.",
  },
  {
    nombre: "El Jardín de las lechuzas",
    link: "https://maps.app.goo.gl/WkVt6Rdj8bNPHuDu9",
    direccion: (
      <>
        Ubicado en: Museo Nacional de Malvinas
        <br />
        351 3483100
      </>
    ),
  },
];

const ReferenciasGenerales = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon
            icon={faMapLocationDot}
            style={{ color: "#c0392b", marginRight: 8 }}
          />
          Referencias Generales
        </h5>
        <ul className="lista-referencias">
          {referenciasCol1.map((ref, i) => (
            <li key={i}>
              <FontAwesomeIcon
                icon={faMapLocationDot}
                style={{ marginRight: 8 }}
              />
              <a href={ref.link} target="_blank" rel="noopener noreferrer">
                {ref.nombre}
              </a>
              <div className="ms-2 me-auto">{ref.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-6">
        <ul className="lista-referencias">
          {referenciasCol2.map((ref, i) => (
            <li key={i}>
              <FontAwesomeIcon
                icon={faMapLocationDot}
                style={{ marginRight: 8 }}
              />
              <a href={ref.link} target="_blank" rel="noopener noreferrer">
                {ref.nombre}
              </a>
              <div className="ms-2 me-auto">{ref.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default ReferenciasGenerales;
